import { LEPC_IDS } from "../../../constants";
import { StaffActivitiesByDescription } from "../../types";

export const staffActivities: StaffActivitiesByDescription = {
  "New Jersey State Portal": {
    parameters: {
      linkUrls: [
        "https://my.nj.gov/aui/Login?goto=https://www9.nj.gov/DEP_RSP/Authenticate.do?method=njdep",
      ],
      staffInputs: {
        documentTypes: {
          report: true,
        },
      },
    },
    jurisdictionType: "State",
    activityType: "Portal",
    state: "NJ",
  },
  "Howell Township Form and Fees": {
    parameters: {
      linkUrls: ["https://www.notion.so/encamp/Howell-Township-07f633c5e1184b4bb6697664c004aeca"],
      staffInputs: {
        fees: true,
        documentTypes: {
          submission: true,
          invoice: true,
        },
      },
      includeLepcs: [
        {
          id: LEPC_IDS.NJ.HOWELL_TOWNSHIP,
          name: "Howell Township (1319)",
        },
      ],
    },
    jurisdictionType: "City/County",
    activityType: "Portal",
    state: "NJ",
  },
};
